import React from 'react';
import Dropdown, {DropdownItem} from "components/Dropdown";
import {useNavigate} from "react-router-dom";
import {useAuth} from "context/AuthContext";
import {Event} from 'types/Event';
import {EyeIcon, PencilIcon, TrashIcon} from "@heroicons/react/solid";

// Types ----

type EventContextMenuProps = {
  event: Event
  onDeleteEvent: () => void
  viewDisabled?: boolean
  editDisabled?: boolean
  deleteDisabled?: boolean
}

// Component ----

function EventContextMenu({event, onDeleteEvent, viewDisabled, editDisabled, deleteDisabled}: EventContextMenuProps) {
  const navigate = useNavigate();
  const auth = useAuth();

  function viewEvent() {
    void navigate(`/events/${event.id}`)
  }

  function editEvent() {
    void navigate(`/events/${event.id}/edit`)
  }

  return (
    <Dropdown>
      {auth.can('events:read') &&
        <DropdownItem name="View" icon={EyeIcon} onClick={viewEvent} disabled={!!viewDisabled}/>
      }

      {auth.can('events:write') &&
        <DropdownItem name="Edit" icon={PencilIcon} onClick={editEvent} disabled={!!editDisabled}/>
      }

      {auth.can('events:write') &&
        <DropdownItem name="Delete" icon={TrashIcon} onClick={onDeleteEvent} disabled={!!deleteDisabled}/>
      }
    </Dropdown>
  );
}

export default EventContextMenu;